// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3361":"b1dc62d9","3531":"8e10d8d3","8474":"1f64894d"}[chunkId] + ".css";
};